import orgzImage from "../images/OrgZ-GD.png";

export const printContactList = (contact, rows, groupeInfos = {}) => {
  const { nom, emoji, couleur } = groupeInfos;
  const header = `<div style="color:${couleur}; font-size:1.2rem; font-weight:bold;">
    ${emoji || "🧩"} ${nom || "Groupe"}
  </div>`;

  const contactField = `contact_${contact._id}`;
  console.log("Exemple row :", rows[0], "contactField:", contactField);

  const printableRows = (rows || [])
  .filter(row => {
    if (!row) return false;
    const valeur = Number(row[contactField]) || 0;
    return valeur > 0; // ✅ garde seulement les items pris
  })

  .map(row => {
    const valeur = Number(row[contactField]) || 0;

    return {
      quoi: row.quoi?.label || "",
      moment: row.quoi?.moment || "",
      valeurContact: valeur
    };
  });


  const logoUrl = orgzImage;

  const htmlContent = `
  <html>
    <head>
      <title>Contact & Quoi</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        h1 { font-size: 18px; margin-bottom: 10px; text-align: center; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
        th { background-color: #f4f4f4; }
        .logo { max-height: 80px; display: block; margin: 0 auto 20px auto; }
        .actions { text-align:center; margin-top:20px; }
        .actions button {
          padding:8px 16px; font-size:14px; cursor:pointer; margin:0 10px;
        }
      </style>
    </head>
    <body>
      <img src="${logoUrl}" alt="Logo" class="logo" />
      ${header}
      <h1>🛒 Liste de courses pour ${contact.nom}</h1>
      <table>
        <thead>
          <tr>
            <th>Quoi</th>
            <th>${contact.nom}</th>
          </tr>
        </thead>
        <tbody>
          ${printableRows
            .map(r => `<tr>
              <td>${r.quoi}</td>
              <td>${r.valeurContact}</td>
            </tr>`)
            .join("")}
        </tbody>
      </table>

      <!-- Boutons d'action -->
      <div class="actions">
        <button onclick="window.print()">🖨️ Imprimer</button>
        <button onclick="window.close()">❌ Fermer</button>
      </div>
    </body>
  </html>
  `;

  const printWindow = window.open(
    "",
    "_blank",
    "width=800,height=600,scrollbars=yes,resizable=yes"
  );

  printWindow.document.write(htmlContent);
  printWindow.document.close();
};
